//https://editor.method.ac/
import React from 'react';

class WhiteboardSvg extends React.Component {
	render() {
    return (
    	<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" clipRule="evenodd" {...this.props}>
		 <g>
		  <g stroke="null" id="svg_32">
		   <g stroke="null" transform="matrix(0.04693160110137043,0,0,0.04693160110137043,-3.11551047829337,12.707670467311628) " id="svg_14">
		    <path stroke="null" id="svg_15" d="m567.07533,46.58801l-32.253,0l0,-303.97l-425.493,0l0,303.97l-32.254,0l0,21.215l177.874,0l-31.967,160.702l20.935,4.113l32.785,-164.815l34.707,0l0,121.308l21.331,0l0,-121.308l24.469,0l32.775,164.815l20.935,-4.112l-31.957,-160.702l188.113,0l0,-21.216zm-53.584,0l-382.831,0l0,-282.755l382.831,0l0,282.755z"/>
		    <rect stroke="null" id="svg_16" height="21.215" width="109.216" y="4.15801" x="189.89333"/>
		   </g>		   
		  </g>
		 </g>
		</svg>      	
    );
  }
}

export default WhiteboardSvg;


// WEBPACK FOOTER //
// ./src/containers/components/svg/WhiteboardSvg.js